import Link from '@components/Link';
import PropTypes from 'prop-types';

import classnames from 'classnames';
import { isDevelopment } from '@utilities/environment';
import linkShape from '@features/WordPress/utilities/prop-types/shapes/link';
import {
  List,
  MenuOpen,
  MenuItem,
  MenuLink,
  MenuLinkActive,
  MenuLinkHover,
} from './Navigation.module.css';

const Navigation = ({ className, items, onClick, menuIsOpen }) => {
  const classes = classnames(
    List,
    {
      [MenuOpen]: menuIsOpen,
    },
    className
  );

  // Function to adjust the URL based on environment
  const getLocalUrlOnDevelopment = (url) => {
    const wordpressUrl = 'https://washworld.test';
    const localUrl = 'http://localhost:3000';

    if (isDevelopment) {
      return url.replace(wordpressUrl, localUrl);
    }

    return url;
  };

  return (
    <ul className={classes}>
      {items &&
        items.map(({ link: { url, title } = {} }) => (
          <li key={JSON.stringify(title, url)} className={MenuItem}>
            <Link
              className={MenuLink}
              activeClassName={MenuLinkActive}
              hoverClassName={MenuLinkHover}
              href={getLocalUrlOnDevelopment(url)}
              onClick={onClick}
              external={true}
            >
              {title}
            </Link>
          </li>
        ))}
    </ul>
  );
};

Navigation.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      link: linkShape,
    })
  ).isRequired,
};

export default Navigation;
